import styled from "@emotion/styled";

export const Container = styled.div`
    display: flex;
    position: absolute;
    left: 32px;
    top: 24px;
    pointer-events: none;
    min-width: 200px;
    @media screen and (max-width: 768px) {
        right: 24px;
        left: 24px;
        justify-content: space-between;
    }
  
    > * {
        z-index: 1;
        margin: 0 24px 0 0;
        @media screen and (max-width: 768px) {
            margin-right: 16px;
        }
        &:last-child {
            margin: 0;
        }
    }     
`

export const MenuContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction:row;   

    @media screen and (max-width: 768px) {
        svg{
            height: 18px;
        }
    } 
`

export const LogoContainer = styled.div`
    display: flex;
    img {
        height : 64px;
    }
`

export const Username = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
`

export const AvatarContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 10px;

    button {
        justify-content: flex-start;
        max-width: calc(100vw - 220px);
    }
    button:disabled {
        pointer-events: none;
    }

    img {
        min-height: 32px;
        min-width: 32px;
    }
`

export const UserContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction:row;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    padding: 18px 24px 18px 18px;
    position: relative;
    gap: 18px;

    &::after {
        content: '';
        display: block;
        position: absolute;
        box-sizing: border-box;
        left: 4px;
        right: 4px;
        top: 4px;
        bottom: 4px;

        border: 1px solid rgba(255, 255, 255, 0.15);
        flex: none;
        order: 1;
        flex-grow: 0;
        z-index: 1;
    }

    &.revers {
        background: rgba(255, 255, 255, 0.5);
        padding: 8px 16px 8px 8px;
    
        &::after {
            border: 1px solid rgba(0, 0, 0, 0.15);
            left: 2px;
            right: 2px;
            top: 2px;
            bottom: 2px;
        }
    }

    > * {
        flex:0 1 auto; 
    }
    @media screen and (max-width: 768px) {
        flex:1 1 auto;
        
        svg{
            height: 28px;
        }
    }
 
    > button {
        pointer-events: all;
      
    }     
`